import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useActiveUser } from "hooks/redux/useActiveUser";
import { Loader } from "components/Common/Loader";
import { logError } from "utils/notifications";
import { StudentClassroomContent } from "content";
import { Route } from "constants/routes";

/**
 * Landing route for links that only know courseId/lessonId (no studentId,
 * e.g. links generated externally). Resolves the logged-in user's own
 * studentId and redirects to the full student classroom lesson URL,
 * carrying the query string (chapterId/exerciseId/t) along unchanged.
 */
export const StudentClassroomCourseLessonRedirect: React.FC = () => {
  const { courseId, lessonId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { activeUser } = useActiveUser();

  useEffect(() => {
    if (activeUser?.studentId) {
      navigate(
        Route.App.Study.STUDENT_CLASSROOM_COURSE_LESSON.construct(
          activeUser.studentId,
          courseId,
          lessonId
        ) + location.search,
        { replace: true }
      );
      return;
    }

    logError({
      message: StudentClassroomContent.Error.NO_CURRENT_STUDENT,
    });
    navigate(Route.App.Schedule.ROOT.path, { replace: true });
  }, [activeUser?.studentId, courseId, lessonId, location.search, navigate]);

  return <Loader isFullScreen />;
};
